export const feedbackUrls: Record<string, string> = {
  de: 'https://backster.typeform.com/to/AYyhwU',
  es: 'https://backster.typeform.com/to/mWmcCC',
  fr: 'https://backster.typeform.com/to/y334qE',
}
export const feedbackUrlFallback = 'https://backster.typeform.com/to/grHtVQ'
